import { useEffect, useState } from "react";
import { Group, Shape, Text } from "react-konva";
import { StaticObj } from "../../interface/StaticObject";
import { ICategoryAssignments } from "../../interface/ICategoryAssignments";
import { IDataHover } from "../../interface/DataHover";
import { ISector } from "../../interface/ISector";


function getColor(isBooked: any, isSelected: any, fill: any) {
    if (isSelected) {
        return "black";
    } else if (isBooked) {
        return "lightgrey";
    } else {
        return fill;
    }
}

const mouseEnter = ({ e, props, isBooked }: any) => {
    e.target._clearCache();
    const container = e.target.getStage().container();
    // console.log(props.sectorData)
    if (isBooked) {
        container.style.cursor = "not-allowed";
    } else {
        container.style.cursor = "pointer";
        const pos = e.target.getAbsolutePosition()
        const sector = props.sectorData as ISector;
        const dataHover = {
            id: sector.id,
            row: sector.name,
            //   place: seat.place,
            price: 0,
            cursor: 'pointer',
            pos: {
                x: pos.x,
                y: pos.y
            },
            assignmentType: 2
        } as IDataHover;
        props.onHover(dataHover);
    }
}

export const SectorObject = (props: any) => {
    // console.log(props)
    // const [groupTag, setGroupTag] = useState()
    const [isBooked, setIsBooked] = useState<boolean>(true)
    const [sectorBlockSize, setSectorBlockSize] = useState({ x: 0, y: 0 })
    const [assign, setAssign] = useState<ICategoryAssignments | null>(null)

    useEffect(() => {
        const sessionAssignments = props.sessionAssignments as ICategoryAssignments[];
        // console.log(sessionAssignments)
        // console.log(props.sectorData)
        const assign = sessionAssignments?.find((cat: ICategoryAssignments) => cat.targetId === props.sectorData.id)
        if (assign) {
            setAssign(assign)
            setIsBooked(assign.orderItemsQuantity >= assign.limit)
        }
        else {
            setIsBooked(false)
        }
    }, [props])
    // const isBooked = props.data.status === "booked";
    const clickOnSeat = () => {
        const assignmentType = 2
        if (isBooked) {
            return;
        }
        if (props.isSelected) {
            props.onDeselect({
                id: props.sectorData.id, groupTag: null, assignmentType: assignmentType
            });
        } else {

            props.onSelect({
                id: props.sectorData.id, groupTag: null, assignmentType: assignmentType
            });
        }
    }

    const object = JSON.parse(props.sectorData.objectData) as StaticObj;
    useEffect(() => {
        const objectJSON = JSON.parse(props.sectorData.objectData) as StaticObj;

        if (objectJSON?.ctxs?.length) {
            const max_x = object.ctxs.reduce((max, ctx) => Math.max(max, ctx.x), -Infinity);
            const max_y = object.ctxs.reduce((max, ctx) => Math.max(max, ctx.y), -Infinity);
            // console.log("Max X:", max_x);
            // console.log("Max Y:", max_y);
            setSectorBlockSize({
                x: max_x,
                y: max_y
            })
        }
    }, [props]);

    return (
        <Group
            onClick={() => {
                clickOnSeat()
            }}
            onTap={() => {
                clickOnSeat()
            }}
            onMouseEnter={e => {
                mouseEnter({ e, props, isBooked })
            }}
            onMouseLeave={e => {
                props.onHover(null);
                const stage = e.target.getStage() as any | null;
                const container = stage.container();
                container.style.cursor = "";
                if (stage) {
                }
            }}
        // draggable={true}
        // ref={sectorGroupRef}
        // onDragEnd={(e) => { handleDragEnd(e) }}
        >
            <Shape
                strokeWidth={typeof object.strokeWidth === 'string' ? parseInt(object.strokeWidth) : object.strokeWidth}
                stroke={object.stroke}
                rotation={typeof object.rotation === 'string' ? parseInt(object.rotation) : object.rotation}
                x={typeof object.x === 'string' ? parseInt(object.x) : object.x}
                y={typeof object.y === 'string' ? parseInt(object.y) : object.y}
                width={typeof object.width === 'string' ? parseInt(object.width) : object.width}
                fill={getColor(isBooked, props.isSelected, assign?.color == null ? "#a3a3a3" : assign.color)}
                sceneFunc={(context, shape) => {
                    context.beginPath();
                    object.ctxs.forEach(ctx => {
                        switch (ctx.type) {
                            case 'move':
                                return context.moveTo(typeof ctx.x === 'string' ? parseInt(ctx.x) : ctx.x, typeof ctx.y === 'string' ? parseInt(ctx.y) : ctx.y);
                            case 'line':
                                return context.lineTo(typeof ctx.x === 'string' ? parseInt(ctx.x) : ctx.x, typeof ctx.y === 'string' ? parseInt(ctx.y) : ctx.y);
                            case 'curve':
                                return context.quadraticCurveTo(typeof ctx.cpx === 'string' ? parseInt(ctx.cpx) : ctx.cpx, typeof ctx.cpy === 'string' ? parseInt(ctx.cpy) : ctx.cpy, typeof ctx.x === 'string' ? parseInt(ctx.x) : ctx.x, typeof ctx.y === 'string' ? parseInt(ctx.y) : ctx.y)
                            default: return null;
                        }
                    });
                    context.closePath();
                    context.fillStrokeShape(shape);
                }}
            />
            <Text
                rotation={typeof object.rotation === 'string' ? parseInt(object.rotation) : object.rotation}
                text={props.sectorData.name}
                x={typeof object.x === 'string' ? parseInt(object.x) : object.x}
                y={typeof object.y === 'string' ? parseInt(object.y) : object.y}
                fill="#fff"
                fontSize={30 / 1.8}
                align="center"
                verticalAlign="middle"
                width={sectorBlockSize.x}
                height={sectorBlockSize.y}
                zIndex={100}
            />
        </Group>

    )
}